import request from 'api/requestUtils'

const METASEARCH_DISCOUNT_API_TIMEOUT_MS = 5000

export interface ResolveMetasearchDiscountInput {
  token: string
  propertyId: string
  checkIn: string
  checkOut: string
  price: number
}

export interface ResolveMetasearchDiscountResponse {
  discountAmount: number
}

export function resolveMetasearchDiscount(
  input: ResolveMetasearchDiscountInput,
): Promise<ResolveMetasearchDiscountResponse> {
  return request.post<ResolveMetasearchDiscountResponse, ResolveMetasearchDiscountInput>(
    '/api/connections/google/discount-resolve',
    input,
    { timeout: METASEARCH_DISCOUNT_API_TIMEOUT_MS },
  ).then(response => ({
    discountAmount: response?.discountAmount ?? 0,
  })).catch(() => ({
    discountAmount: 0,
  }))
}
